import type { ReportFilterOptions } from '@reports/domain/value-objects';
import type { FilterOptionsViewDto } from '@reports/application/dtos';

/**
 * Maps ReportFilterOptions array to View Dto format
 *
 * Transforms domain Value Objects to presentation-ready format
 *
 * @param filterOptions - Array of ReportFilterOptions Value Objects
 * @returns View Dto with filters organized by key
 */
export const mapFilterOptionsToViewDto = (filterOptions: ReadonlyArray<ReportFilterOptions>): FilterOptionsViewDto => {
  const filters: Record<string, ReadonlyArray<Readonly<{ key: string; value: string }>>> = {};

  filterOptions.forEach((filterOption) => {
    filters[filterOption.type] = filterOption.optionValues;
  });

  return { filters };
};
